import { createReducer } from 'typesafe-actions'
import { GetHistoryRequestDto, GetHistoryResponseDto, HistoryEntity } from '@sparling/financial-common'
import {
  getHistoryFailure,
  getHistoryRequest,
  getHistorySuccess,
  resetHistoryFilters,
  setHistoryFilters,
} from '../actions'
import { ActionTypes } from '../types'
import { LoadingState } from '../../types'

export type HistoryState = {
  status: LoadingState
  filters: GetHistoryRequestDto
  data: GetHistoryResponseDto
  error: Error | null
}

export const initialState: HistoryState = {
  status: 'IDLE',
  filters: {
    page: 1,
    limit: 10,
    type: HistoryEntity.ALL,
  },
  data: {
    meta: { totalItems: 0, itemCount: 0, itemsPerPage: 10, totalPages: 0, currentPage: 1 },
    items: [],
  },
  error: null,
}

export const history = createReducer<HistoryState, ActionTypes>(initialState)
  .handleAction(getHistoryRequest, (state) => ({
    ...state,
    status: 'LOADING',
  }))
  .handleAction(getHistorySuccess, (state, { payload }) => ({
    ...state,
    status: 'SUCCESS',
    data: payload,
  }))
  .handleAction(getHistoryFailure, (state, { payload }) => ({
    ...state,
    status: 'ERROR',
    error: payload,
  }))
  .handleAction(setHistoryFilters, (state, { payload }) => ({
    ...state,
    filters: { ...state.filters, ...payload, page: 1 },
  }))
  .handleAction(resetHistoryFilters, (state) => ({
    ...state,
    filters: initialState.filters,
  }))
